module.exports = __webpack_public_path__ + "img/inktober_2020_24_buddy.cc5e2cff.jpg";